import BaseService from "@/services/Base-service.js";

class LabelService {
  get controllerName() { return '/Label/'; }

  listCompanyLabels(isDeleted) {
    return BaseService.get(this.controllerName + 'ListCompanyLabels', { isDeleted });
  }

  toggleLabelForTicket(labelId, ticketId) {
    return BaseService.post(this.controllerName + 'ToggleLabelForTicket?labelId=' + labelId + '&ticketId=' + ticketId, {});
  }
}

export default new LabelService();